module.exports = __webpack_public_path__ + "static/media/new-messages.f22d50fe.svg";